export default __webpack_public_path__ + "static/media/full-logo.7cb95cf8.svg";